import React from 'react';

import init from './methods/init.ts';
import prevInit from './methods/prevInit.ts';
import start from './methods/start.ts';

import MainPreviewI from './types.ts';

import renderEnd from './renders/renderEnd.tsx';
import renderStart from './renders/renderStart.tsx';
import style from './static/style.ts';

class MainPreview
    extends React.Component<MainPreviewI['props'], MainPreviewI['state']>
    implements MainPreviewI
{
    startPreview: MainPreviewI['startPreview'];
    endPreview: MainPreviewI['endPreview'];

    constructor(props: MainPreviewI['props']) {
        super(props);

        const mainPreviewTime =
            typeof window !== 'undefined' ? localStorage.getItem('mainPreviewTime') : null;

        if (
            mainPreviewTime &&
            !Number.isNaN(+mainPreviewTime) &&
            new Date().getTime() > +mainPreviewTime + 60_000 * 60 * 24
        ) {
            localStorage.removeItem('mainPreviewShow');
            localStorage.removeItem('mainPreviewTime');
        }

        this.state = {
            isShow:
                typeof window !== 'undefined' ? !!localStorage.getItem('mainPreviewShow') : false,
            isStart: false,
            isPreviewImageReady: false,
        };

        this.startPreview = React.createRef();
        this.endPreview = React.createRef();
    }

    ready = {
        start: false,
        end: false,
        process: false,
    };
    style = style;

    init = init;
    prevInit = prevInit;
    start = start;

    renderStart = renderStart;
    renderEnd = renderEnd;

    render() {
        const { windowIsLoad } = this.props;

        return (
            <>
                {windowIsLoad && (
                    <>
                        {this.renderStart()}
                        {this.renderEnd()}
                    </>
                )}
            </>
        );
    }
}

export default MainPreview;
